import categories from './categories';
import providers from './providers';

export default [categories, providers];
